// extracted by mini-css-extract-plugin
export default {"disabled":"SplitScreenPanel-module__disabled___Z4mz9"};